import integrationsTranslations from './integrationsTranslations.js';
import en from './en.js';
import es from './es.js';
import it from './it.js';
import fr from './fr.js';
import sv from './sv.js';
import pt from './pt.js';
import de from './de.js';
import pl from './pl.js';
import da from './da.js';

export default {
    integrations: integrationsTranslations,
    es,
    en,
    fr,
    it,
    sv,
    pt,
    de,
    pl,
    da,
};
